import {Action, Module, Mutation} from 'vuex-module-decorators'
import store from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import EcrfAuditTrailClient = MdbsCore.EcrfAuditTrailClient;
import AuditValueChangeDto = MdbsCore.AuditValueChangeDto;

const client = new EcrfAuditTrailClient()

@Module({namespaced: true, name: 'auditTrail', store: store})
export default class AuditTrailModule extends BaseModule {
    _auditChanges: Array<AuditValueChangeDto> = [];

    get auditChanges() {
        return this._auditChanges;
    }

    @Mutation
    stopLoading() {
        this.loading = false;
    }

    @Mutation
    reset() {
        this._auditChanges.clear();
    }

    @Mutation
    setAuditChanges(auditChanges: Array<AuditValueChangeDto>) {
        this._auditChanges.updateValues(auditChanges);
    }

    @Action({rawError: true})
    async loadForStuyPatient(id: string) {
        this.startLoading();
        this.reset();
        await this.execute(async () => {
            this.setAuditChanges(await client.getStudyPatientAuditTrail(id, "de"))
        }).catch(() => this.reset());

        this.stopLoading();
    }

    @Action({rawError: true})
    async loadForVisit(id: string) {
        this.startLoading();
        this.reset();
        await this.execute(async () => {
            this.setAuditChanges(await client.getVisitAuditTrail(id, "de"))
        }).catch(() => this.reset());

        this.stopLoading();
    }

    @Action({rawError: true})
    async loadForInstrument(id: string) {
        this.startLoading();
        this.reset();
        await this.execute(async () => {
            this.setAuditChanges(await client.getInstrumentAuditTrail(id, "de"))
        }).catch(() => this.reset());

        this.stopLoading();
    }

    @Action({rawError: true})
    async loadForQuery(id: string) {
        this.startLoading();
        this.reset();
        await this.execute(async () => {
            this.setAuditChanges(await client.getQueryAuditTrail(id, "de"))
        }).catch(() => this.reset());

        this.stopLoading();
    }

    @Action({rawError: true})
    async loadForStudyInstitute(id: string) {
        this.startLoading();
        this.reset();
        await this.execute(async () => {
            this.setAuditChanges(await client.getStudyInstituteAuditTrail(id, "de"))
        }).catch(() => this.reset());

        this.stopLoading();
    }

    @Action({rawError: true})
    async loadForUser(id: string) {
        this.startLoading();
        this.reset();
        await this.execute(async () => {
            this.setAuditChanges(await client.getUserAuditTrail(id, "de"))
        }).catch(() => this.reset());

        this.stopLoading();
    }
}
